/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserInfoFromJSON, UserInfoToJSON } from './UserInfo';
/**
 * Check if a given object implements the AuthMeResponse interface.
 */
export function instanceOfAuthMeResponse(value) {
    if (!('user' in value) || value['user'] === undefined)
        return false;
    return true;
}
export function AuthMeResponseFromJSON(json) {
    return AuthMeResponseFromJSONTyped(json, false);
}
export function AuthMeResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'message': json['message'] == null ? undefined : json['message'],
        'user': UserInfoFromJSON(json['user']),
    };
}
export function AuthMeResponseToJSON(json) {
    return AuthMeResponseToJSONTyped(json, false);
}
export function AuthMeResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'message': value['message'],
        'user': UserInfoToJSON(value['user']),
    };
}
